import { render, staticRenderFns } from "./BaseImageThumbnail.vue?vue&type=template&id=61a81885&scoped=true&"
import script from "./BaseImageThumbnail.vue?vue&type=script&lang=js&"
export * from "./BaseImageThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./BaseImageThumbnail.vue?vue&type=style&index=0&id=61a81885&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a81885",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a81885')) {
      api.createRecord('61a81885', component.options)
    } else {
      api.reload('61a81885', component.options)
    }
    module.hot.accept("./BaseImageThumbnail.vue?vue&type=template&id=61a81885&scoped=true&", function () {
      api.rerender('61a81885', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseImageThumbnail.vue"
export default component.exports